import React, { useState, useEffect } from 'react';
import Pagination from 'react-js-pagination';
import { useSelector } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useMutation, useQuery } from 'react-query';
import { Image } from 'react-bootstrap';
import { AsyncPaginate } from 'react-select-async-paginate';
import { SIGNEDHUMAN_API, FILE_MANAGER_API, BaseGatewayImage, KYSO_API } from '@app/utils/apiUrl.js';
import { DeleteSingle, Get, Post } from '@app/utils/httpProvider';
import {
    createUrlWithParam,
    formatDateTimeCrawler,
    formatDateTimeMoment,
    formatDateTimeWithoutHour,
    formatDateTimeWithoutHourMoment,
    getInfomationAccountFromToken,
    isValidUrl
} from '../../utils/helper';
import { URI_INTERNAL } from '../../utils/pathLocations';
import {
    objectShowNumber,
    messageToast,
    styleSelectDefault,
    role,
    objectTrangThaiDeNghi,
    trangThaiDeNghiValue,
    objectLoaiKy,
    status200
} from '../../utils/define';
import { ConfirmModal } from '../../modules/modal/ConfirmModal';
import { BrowserView, MobileView } from 'react-device-detect';
import Select from 'react-select';

const SignedHuman = () => {
    const history = useHistory();
    const location = useLocation();
    // if (!location) return null;
    const valueSearch = useSelector((state) => state.search.valueSearch);

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [search, setSearch] = useState('');

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');

    const [selectedIds, setSelectedIds] = useState([]);

    const [openBulkActionModal, setOpenBulkActionModal] = useState(false);
    const [bulkUsername, setBulkUsername] = useState('');
    const [bulkPassword, setBulkPassword] = useState('');

    const [bulkLoaiKy, setBulkLoaiKy] = useState(
        objectLoaiKy && objectLoaiKy.length > 0 ? objectLoaiKy[0].value : ''
    );

    const [docxFileId, setDocxFileId] = useState('');
    const [docxFilePath, setDocxFilePath] = useState('');

    // let accountRoleAdmin = false;
    // const inforAccount = getInfomationAccountFromToken();

    // if (inforAccount && inforAccount.role) {
    //     const userRole = inforAccount.role;
    //     accountRoleAdmin =
    //         userRole.includes(role.Admin) || userRole.includes(role.Editor);
    // }

    const deleteFunc = useMutation((value) =>
        DeleteSingle(SIGNEDHUMAN_API.DELETE_ITEM, value, null)
    );

    const paramUrl = new URLSearchParams(location.search.substring(1));
    if (
        paramUrl.get('page') != null &&
        parseInt(paramUrl.get('page'), 10) !== page
    ) {
        const pageResult = parseInt(paramUrl.get('page'), 10);
        setPage(pageResult);
    }
    if (
        paramUrl.get('size') != null &&
        parseInt(paramUrl.get('size'), 10) !== pageSize
    ) {
        const sizeResult = parseInt(paramUrl.get('size'), 10);
        setPageSize(sizeResult);
    }
    if (paramUrl.get('search') != null && paramUrl.get('search') !== search) {
        setSearch(paramUrl.get('search'));
    }

    // const [isSortedNameAlphabet, setIsSortedNameAlphabet] = useState(false);

    const { isLoading, isError, error, data, refetch } = useQuery(
        ['signedHumanData', valueSearch, page, pageSize],
        () => {
            let model = {
                Keyword: valueSearch ? valueSearch : '',
                PageIndex: page,
                PageSize: pageSize
            };

            replaceHistory(page, pageSize, valueSearch ? valueSearch : '');

            return Get(SIGNEDHUMAN_API.GET_PAGING, null, model);
        }
    );

    useEffect(() => {
        refetch();
    }, [pageSize, page]);

    const replaceHistory = async (Page, Size, Search) => {
        history.replace(
            createUrlWithParam(URI_INTERNAL.SIGNED_HUMAN_PATH, {
                page: Page,
                size: Size,
                search: Search
            })
        );
    };

    React.useEffect(() => {
        if (valueSearch != null && valueSearch !== search) {
            replaceHistory(1, pageSize, valueSearch);
        }
    }, [valueSearch]);

    const changePage = (number) => {
        setPage(number);
        replaceHistory(number, pageSize, search);
    };

    const onChangeShowNumber = (e) => {
        setPageSize(e.target.value);
        replaceHistory(page, e.target.value, search);
    };

    const deleteAction = (id, name) => {
        setIdWantDelete(id);
        setConfirmDelMessage(name);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = async () => {
        if (idWantDelete !== '') {
            deleteFunc.mutate(idWantDelete, {
                onSuccess: (res) => {
                    if (res.status === 201 || res.status === 200) {
                        refetch();
                        toast.success(messageToast.messageToastDeleteSuccess);
                        if (
                            data != null &&
                            data.items.length === 1 &&
                            page !== 1
                        ) {
                            history.push(
                                createUrlWithParam(
                                    URI_INTERNAL.SIGNED_HUMAN_PATH,
                                    {
                                        page: page - 1,
                                        size: pageSize,
                                        search: search
                                    }
                                )
                            );
                        }
                    } else {
                        toast.error(messageToast.messageToastDeleteError);
                    }
                },
                onError: (res) => {
                    toast.error(messageToast.messageToastTryCatch);
                }
            });

            replaceHistory(page, pageSize, search);
            setOpenConfirmDeleteModal(false);
        }
    };

    const cancelDelete = () => {
        setIdWantDelete('');
        setOpenConfirmDeleteModal(false);
    };

    const handleSelectOne = (id) => {
        setSelectedIds((prev) => {
            if (prev.includes(id)) {
                return prev.filter((x) => x !== id);
            }
            return [...prev, id];
        });
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allIds =
                data?.data?.map((item) => item.id) || [];
            setSelectedIds(allIds);
        } else {
            setSelectedIds([]);
        }
    };

    const isAllSelected =
        data?.data?.length > 0 &&
        data.data.every((item) => selectedIds.includes(item.id));

    // const handleSignMultiple = async () => {
    //     if (selectedIds.length === 0) {
    //         toast.warning('Vui lòng chọn ít nhất một bản ghi');
    //         return;
    //     }

    //     try {
    //         for (const id of selectedIds) {
    //             await deleteFunc.mutateAsync(id);
    //         }

    //         toast.success('Xóa nhiều bản ghi thành công');
    //         setSelectedIds([]);
    //         refetch();
    //     } catch (error) {
    //         toast.error('Có lỗi khi xóa nhiều bản ghi');
    //     }
    // };

    const handleOpenBulkActionModal = () => {
        if (selectedIds.length === 0) {
            toast.warning('Vui lòng chọn ít nhất một bản ghi');
            return;
        }

        setBulkUsername('');
        setBulkPassword('');
        setOpenBulkActionModal(true);
    };

    const handleCloseBulkActionModal = () => {
        setOpenBulkActionModal(false);
        setBulkUsername('');
        setBulkPassword('');
    };

    const exportPdfFunc = useMutation((value) =>
        Post(SIGNEDHUMAN_API.EXPORT_USERS_PDF, null, value, false)
    );

    // const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    // const sanitizeFileName = (value) => {
    //     if (!value) return 'SignedHuman';
    //     return value
    //         .replace(/[<>:"/\\|?*\x00-\x1F]/g, '_')
    //         .replace(/\s+/g, ' ')
    //         .trim();
    // };

    const exportUserPdf = async () => {
        if (!selectedIds || selectedIds.length === 0) {
            toast.warning('Vui lòng chọn ít nhất một bản ghi');
            return;
        }

        if (selectedIds.length > 10) {
            toast.warning('Chỉ được xuất tối đa 10 file mỗi lần');
            return;
        }

        try {
            const selectedUsers = (data?.data || []).filter((x) =>
                selectedIds.includes(x.id)
            );

            if (!selectedUsers.length) {
                toast.warning('Không tìm thấy dữ liệu để xuất file');
                return;
            }

            var model = {
                filePath: docxFilePath,
                lstSelectedUser: selectedUsers
            }

            await exportPdfFunc.mutateAsync(model, {
                onSuccess: (res) => {
                    if (res.status !== status200) {
                        toast.error(messageToast.messageToastCreateError);
                    } else {
                        toast.success(messageToast.messageToastCreateSuccess);
                        replaceHistory(page, pageSize, valueSearch);
                    }
                },
                onError: (res) => {
                    toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
                }
            });

            // for (const user of selectedUsers) {
            //     const model = {
            //         id: user.id || '',
            //         fullName: user.fullName || '',
            //         address: user.address || '',
            //         phoneNumber: user.phoneNumber || ''
            //     };

            //     await exportPdfFunc.mutateAsync(model, {
            //         onSuccess: (res) => {
            //             if (res.status !== status200) {
            //                 toast.error(messageToast.messageToastCreateError);
            //             } else {
            //                 toast.success(messageToast.messageToastCreateSuccess);
            //                 history.goBack();
            //             }
            //         },
            //         onError: (res) => {
            //             toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
            //         }
            //     });

            //     // const response = await fetch(SIGNEDHUMAN_API.EXPORT_USERS_PDF, {
            //     //     method: 'POST',
            //     //     headers: {
            //     //         'Content-Type': 'application/json'
            //     //     },
            //     //     body: JSON.stringify(model)
            //     // });

            //     // if (!response.ok) {
            //     //     toast.error(`Xuất file thất bại: ${user.fullName || user.id}`);
            //     //     continue;
            //     // }

            //     // const blob = await response.blob();

            //     // let fileName = `SignedHuman_${sanitizeFileName(user.fullName)}.pdf`;

            //     // const contentDisposition = response.headers.get('content-disposition');
            //     // if (contentDisposition) {
            //     //     const match = contentDisposition.match(/filename\*=UTF-8''(.+)|filename="?([^"]+)"?/i);
            //     //     if (match) {
            //     //         fileName = decodeURIComponent(match[1] || match[2]);
            //     //     }
            //     // }

            //     // const url = window.URL.createObjectURL(blob);
            //     // const a = document.createElement('a');
            //     // a.href = url;
            //     // a.download = fileName;
            //     // document.body.appendChild(a);
            //     // a.click();
            //     // a.remove();
            //     // window.URL.revokeObjectURL(url);

            //     await sleep(300);
            // }

            toast.success('Đã xử lý xuất file');
        } catch (error) {
            console.error(error);
            toast.error('Đã có lỗi xảy ra khi xuất file');
        }
    };

    const addFunc = useMutation((value) =>
        Post(KYSO_API.KYSO, null, value, false, true)
    );

    const handleConfirmBulkAction = async () => {
        if (!selectedIds || selectedIds.length === 0) {
            toast.warning('Vui lòng chọn ít nhất một bản ghi');
            return;
        }

        if (selectedIds.length > 10) {
            toast.warning('Chỉ được xuất tối đa 10 file mỗi lần');
            return;
        }

        if (!bulkUsername || !bulkPassword) {
            toast.warning('Vui lòng nhập username và password');
            return;
        }
        const model = {
            userName: bulkUsername,
            password: bulkPassword,
            mid: objectLoaiKy.find(x => x.value == bulkLoaiKy).text,
            signatureName: 'chuky_bgd',
            selectedIds: selectedIds
        };

        // model.parentId = values.parentId === 'null' ? '' : values.parentId;
        // model.parentId = '';
        addFunc.mutateAsync(model, {
            onSuccess: async (res) => {
                if (res.status !== status200) {
                    toast.error(messageToast.messageToastCreateError);
                } else {
                    const contentType = res.headers?.['content-type'] || 'application/zip';

                    let fileName = `signed_files_${new Date().getTime()}.zip`;
                    const disposition = res.headers?.['content-disposition'];
                    if (disposition) {
                        const match = disposition.match(/filename="?([^"]+)"?/);
                        if (match && match[1]) {
                            fileName = match[1];
                        }
                    }

                    const blob = await res.blob();

                    if (!blob || blob.size === 0) {
                        toast.error('File zip rỗng hoặc không hợp lệ');
                        return;
                    }

                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();

                    window.URL.revokeObjectURL(url);

                    toast.success(messageToast.messageToastCreateSuccess);
                    setOpenBulkActionModal(false);
                    replaceHistory(page, pageSize, valueSearch);
                }
            },
            onError: (res) => {
                toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
            }
        });
    };

    const loadOptionsDocxFile = async (search, loadedOptions, { page }) => {
        const pageSize = 10;
        const res = await Get(FILE_MANAGER_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            Keyword: search, // pass the input text to filter server-side
            FileType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.filePath}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: { page: page + 1 }
        };
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">
                                {' '}
                                Danh sách nội dung đề nghị
                            </h3>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between">
                                <form className="form-inline">
                                    <label
                                        htmlFor="exampleEmail2"
                                        className="mr-2"
                                    >
                                        Hiển thị :
                                    </label>
                                    <select
                                        className="form-control"
                                        value={pageSize}
                                        onChange={(e) => onChangeShowNumber(e)}
                                    >
                                        {objectShowNumber.map((item, key) => (
                                            <option
                                                key={Number(key)}
                                                value={item.value}
                                            >
                                                {item.text}
                                            </option>
                                        ))}
                                    </select>

                                    <AsyncPaginate
                                        name="docxFileId"
                                        id="docxFileId"
                                        placeholder="Chọn file docx"
                                        value={docxFileId}
                                        loadOptions={loadOptionsDocxFile}
                                        styles={styleSelectDefault}
                                        isClearable
                                        onChange={(selectedOption) => {
                                            setDocxFileId(selectedOption);
                                            setDocxFilePath(selectedOption?.label || '');
                                            // setFieldValue(
                                            //     'docxFileId',
                                            //     selectedOption,
                                            //     true
                                            // );
                                        }}
                                        additional={{
                                            page: 1
                                        }}
                                    />

                                    <button
                                        type="button"
                                        className="btn btn-danger mr-2"
                                        onClick={exportUserPdf}
                                    >
                                        Tạo tệp tin
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-danger mr-2"
                                        onClick={handleOpenBulkActionModal}
                                    >
                                        Login để ký lô SIM
                                    </button>
                                </form>
                                <NavLink
                                    className="nav-link-reject nav-link"
                                    to={URI_INTERNAL.SIGNED_HUMAN_CREATE_PATH}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-info"
                                    >
                                        Thêm mới
                                    </button>
                                </NavLink>
                            </div>

                            {isLoading ? (
                                <div>Đang tải...</div>
                            ) : isError ? (
                                <div>Có lỗi xảy ra: ${error.message}</div>
                            ) : (
                                <div
                                    id="example2_wrapper"
                                    className="dataTables_wrapper dt-bootstrap4"
                                // style={{
                                //     marginTop: accountRoleAdmin
                                //         ? '0px'
                                //         : '20px'
                                // }}
                                >
                                    <div className="row">
                                        <div
                                            className="col-sm-12"
                                            style={{ overflow: 'auto' }}
                                        >
                                            <Table striped bordered hover>
                                                <thead>
                                                    <tr role="row">
                                                        <th className="sorting">
                                                            STT
                                                        </th>
                                                        <th className="sorting">
                                                            Họ tên
                                                        </th>
                                                        <th className="sorting">
                                                            Địa chỉ
                                                        </th>
                                                        <th className="sorting">
                                                            Điện thoại
                                                        </th>
                                                        <th>
                                                            <input
                                                                type="checkbox"
                                                                checked={isAllSelected}
                                                                onChange={handleSelectAll}
                                                            />
                                                        </th>
                                                        <th className="sorting">
                                                            Chức năng
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {data != null &&
                                                    data.data != null &&
                                                    data.data != null &&
                                                    data.data !== undefined &&
                                                    data.data.length > 0 ? (
                                                    <tbody>
                                                        {data.data.map(
                                                            (item, index) => (
                                                                <tr
                                                                    key={Number(
                                                                        index
                                                                    )}
                                                                    className="odd"
                                                                >
                                                                    <td className="dtr-control sorting_1">
                                                                        {index +
                                                                            1 +
                                                                            (page -
                                                                                1) *
                                                                            pageSize}
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.fullName
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item.address
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {item.phoneNumber}
                                                                    </td>
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedIds.includes(item.id)}
                                                                            onChange={() => handleSelectOne(item.id)}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <ul className="nav">
                                                                            <li className="nav-item">
                                                                                <NavLink
                                                                                    to={createUrlWithParam(
                                                                                        URI_INTERNAL.SIGNED_HUMAN_EDIT_PATH,
                                                                                        {
                                                                                            id: item.id
                                                                                        }
                                                                                    )}
                                                                                    exact
                                                                                    className="nav-link"
                                                                                >
                                                                                    <i
                                                                                        title="Sửa"
                                                                                        className="nav-icon font-icon fas fa-pen"
                                                                                    />
                                                                                </NavLink>
                                                                            </li>
                                                                            <li className="nav-item">
                                                                                <NavLink
                                                                                    onClick={() =>
                                                                                        deleteAction(
                                                                                            item.id
                                                                                        )
                                                                                    }
                                                                                    to
                                                                                    exact
                                                                                    className="nav-link"
                                                                                >
                                                                                    <i
                                                                                        title="Xóa"
                                                                                        className="nav-icon font-icon far fa-trash-alt"
                                                                                    />
                                                                                </NavLink>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                        <tr className="txt-center">
                                                            <td colSpan="12">
                                                                Không có dữ liệu
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                )}
                                                <tfoot>
                                                    <tr role="row">
                                                        <th className="sorting">
                                                            STT
                                                        </th>
                                                        <th className="sorting">
                                                            Họ tên
                                                        </th>
                                                        <th className="sorting">
                                                            Địa chỉ
                                                        </th>
                                                        <th className="sorting">
                                                            Điện thoại
                                                        </th>
                                                        <th></th>
                                                        <th className="sorting">
                                                            Chức năng
                                                        </th>
                                                    </tr>
                                                </tfoot>
                                            </Table>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div
                                                className="dataTables_paginate paging_simple_numbers"
                                                id="example2_paginate"
                                            >
                                                <Pagination
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                    innerClass="pagination pagination-sm no-margin pull-right"
                                                    activePage={page}
                                                    itemsCountPerPage={Number(
                                                        pageSize
                                                    )}
                                                    totalItemsCount={
                                                        data != null
                                                            ? data.totalRecords
                                                            : 0
                                                    }
                                                    pageRangeDisplayed={5}
                                                    onChange={(number) =>
                                                        changePage(number)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <Modal
                                show={openBulkActionModal}
                                onHide={handleCloseBulkActionModal}
                                centered
                                backdrop="static"
                                keyboard={false}
                                style={{ zIndex: '9999' }}
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>Nhập thông tin xác nhận</Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <Form>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Username</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={bulkUsername}
                                                onChange={(e) => setBulkUsername(e.target.value)}
                                                placeholder="Nhập username"
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control
                                                type="password"
                                                value={bulkPassword}
                                                onChange={(e) => setBulkPassword(e.target.value)}
                                                placeholder="Nhập password"
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Loại ký</Form.Label>
                                            <select
                                                className="form-control"
                                                value={bulkLoaiKy}
                                                onChange={(e) => setBulkLoaiKy(e.target.value)}
                                            >
                                                {objectLoaiKy.map((item, key) => (
                                                    <option key={Number(key)} value={item.value}>
                                                        {item.text}
                                                    </option>
                                                ))}
                                            </select>
                                        </Form.Group>
                                    </Form>
                                </Modal.Body>

                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseBulkActionModal}>
                                        Hủy
                                    </Button>
                                    <Button variant="primary" onClick={handleConfirmBulkAction}>
                                        Xác nhận
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            <ConfirmModal
                                isOpen={openConfirmDeleteModal}
                                confirmType="delete"
                                handleAccept={() => acceptDelete()}
                                handleCancel={() => cancelDelete()}
                                content={confirmDelMessage}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignedHuman;
